import { FunctionComponent, useEffect, useRef } from 'react'
import {
  FinanceWidgetEvents,
  customEvent,
  usePlatformConfig,
} from '@dxp-module/common'
import { Box } from '@mui/material'
import {
  DisclaimerSection,
  FinanceBreakdownData,
} from '../../../../common/model/Breakdown'
import FinanceBreakdown from './breakdown/FinanceBreakdown'
import Disclaimer from './disclaimer/Disclaimer'

type BreakdownDisplayProps = {
  breakdown: string
}

const BreakdownDisplay: FunctionComponent<BreakdownDisplayProps> = ({
  breakdown,
}) => {
  const miniFcUpdated = useRef(false)
  const {
    platformConfig: {
      financeCalculator: { useMiniFc },
    },
  } = usePlatformConfig()

  const targetRef = useRef()

  const schema = JSON.parse(breakdown)
  const financeBreakdownData = schema.schema.properties
    .breakdown as FinanceBreakdownData

  const disclaimers = schema.schema.properties?.disclaimer?.title?.json as [
    DisclaimerSection
  ]

  useEffect(() => {
    if (schema?.schema && useMiniFc && !miniFcUpdated.current) {
      customEvent.emit(FinanceWidgetEvents.FC_DATA, {
        repayment:
          schema.schema?.properties?.form?.title?.json?.properties?.repayment,
      })
      miniFcUpdated.current = true
    }
  }, [schema, useMiniFc])

  if (!schema) {
    useMiniFc && customEvent.emit(FinanceWidgetEvents.FC_DATA, {})
    miniFcUpdated.current = false
    return null
  }

  const renderBreakdown = () => {
    return (
      <FinanceBreakdown
        financeBreakdownData={financeBreakdownData}
        targetRef={targetRef}
      />
    )
  }

  return (
    <div data-test="breakdown-display-section">
      {renderBreakdown()}
      <Box ref={targetRef}>
        <Disclaimer disclaimerData={disclaimers} />
      </Box>
    </div>
  )
}

export default BreakdownDisplay
